import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Flex } from "#shared/view/components/Flex";
import { InlineLoader } from "#shared/view/components/InlineLoader";
import { Text } from "#shared/view/components/Text";

export const AddSectionHeader = ({
  label,
  onAdd,
  color,
  shouldDisplayAddButton = true,
  isLoading = false,
}: {
  label: string;
  onAdd: () => void;
  color?: string;
  shouldDisplayAddButton?: boolean;
  isLoading?: boolean;
}) => {
  return (
    <Flex align={"center"} justify={"space-between"}>
      <Text data-testid="process-step-label" fw={700} c={color} my={"xxs"}>
        {label}
      </Text>
      {isLoading && <InlineLoader size="xs" />}
      {shouldDisplayAddButton && !isLoading && (
        <ActionIcon
          data-testid="add-button"
          size="xs"
          c={"dimmed"}
          variant="subtle"
          onClick={onAdd}
        >
          <Icon name="plus" size={18} />
        </ActionIcon>
      )}
    </Flex>
  );
};
